// extracted by mini-css-extract-plugin
module.exports = {"panel":"Index_panel__JT63A","user":"Index_user__RlJ46"};